var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDragAndDrop = function SvgDragAndDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "drag-and-drop_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".drag-and-drop_svg__st1{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    d: "M50 0c27.6 0 50 22.4 50 50s-22.4 50-50 50S0 77.6 0 50 22.4 0 50 0z",
    style: {
      fill: "#03d47c"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "drag-and-drop_svg__st1",
    d: "M31.8 29.7c0-1.7 1.4-3.1 3-3.1H47c1.7 0 3 1.4 3 3.1v12.5c0 1.7 1.4 3.1 3 3.1h12.1c1.7 0 3 1.4 3 3.1v1.9c-.8-.3-1.7-.4-2.6-.4-4.3 0-7.8 3.5-7.8 7.8-4.3 0-7.8 3.5-7.8 7.8 0 .9.2 1.8.4 2.6H34.8c-1.7 0-3-1.4-3-3.1V29.7zM68.2 63h5.2c1.4 0 2.6 1.2 2.6 2.6 0 1.4-1.2 2.6-2.6 2.6h-5.2v5.2c0 1.4-1.2 2.6-2.6 2.6-1.4 0-2.6-1.2-2.6-2.6v-5.2h-5.2c-1.4 0-2.6-1.2-2.6-2.6 0-1.4 1.2-2.6 2.6-2.6H63v-5.2c0-1.4 1.2-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6V63z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "drag-and-drop_svg__st1",
    d: "m58.3 27.3 9.2 9.5c1.6 1.6.5 4.3-1.7 4.3h-9.2c-1.4 0-2.5-1.1-2.5-2.5v-9.5c-.1-2.2 2.6-3.4 4.2-1.8z"
  })));
};
export default SvgDragAndDrop;